"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldTime = exports.TIME_INITIAL = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
const legacy_1 = require("../Select/legacy");
exports.TIME_INITIAL = '00:00';
const TIME_HOUR_FORMAT = 'HH';
const TIME_MINUTE_FORMAT = 'mm';
const TIME_HOURS = [...Array(24).keys()].map(hour => `${hour}`.padStart(2, '0'));
const TIME_MINUTES = [...Array(60).keys()].map(minute => `${minute}`.padStart(2, '0'));
class FormFieldTime extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.parseDateTimeFromInputValue = () => {
            return (0, moment_1.default)(this.props.value, dateTimeFormat_1.TIME_FORMAT).toDate();
        };
        this.handleHourInputChange = (event) => {
            const { value } = event.target;
            const time = (0, moment_1.default)(value, TIME_HOUR_FORMAT);
            if (time.format(TIME_HOUR_FORMAT) === value) {
                const hours = time.toDate().getHours();
                const datetime = this.parseDateTimeFromInputValue() || new Date();
                datetime.setHours(hours);
                this.props.onChange((0, moment_1.default)(datetime).format(dateTimeFormat_1.TIME_FORMAT), this.props.name);
            }
        };
        this.handleMinuteInputChange = (event) => {
            const { value } = event.target;
            const time = (0, moment_1.default)(value, TIME_MINUTE_FORMAT);
            if (time.format(TIME_MINUTE_FORMAT) === value) {
                const minutes = time.toDate().getMinutes();
                const datetime = this.parseDateTimeFromInputValue() || new Date();
                datetime.setMinutes(minutes);
                this.props.onChange((0, moment_1.default)(datetime).format(dateTimeFormat_1.TIME_FORMAT), this.props.name);
            }
        };
        this.parseHourFromInputValue = () => {
            return (0, moment_1.default)(this.props.value, dateTimeFormat_1.TIME_FORMAT).toDate().getHours();
        };
        this.parseMinuteFromInputValue = () => {
            return (0, moment_1.default)(this.props.value, dateTimeFormat_1.TIME_FORMAT).toDate().getMinutes();
        };
    }
    render() {
        const hour = `${this.parseHourFromInputValue()}`.padStart(2, '0');
        const minute = `${this.parseMinuteFromInputValue()}`.padStart(2, '0');
        const { label, error, modificators } = this.props;
        return (react_1.default.createElement("div", { className: 'form-fields-together' },
            react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { error: error, modificators: modificators, label: label !== null && label !== void 0 ? label : '', value: hour, items: TIME_HOURS, onChange: this.handleHourInputChange }),
            react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { error: error, modificators: modificators, value: minute, items: TIME_MINUTES, onChange: this.handleMinuteInputChange })));
    }
}
exports.FormFieldTime = FormFieldTime;
FormFieldTime.defaultProps = {
    onChange: () => { },
    value: exports.TIME_INITIAL,
};
//# sourceMappingURL=index.js.map